import Auth0Lock from 'auth0-lock';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';

import { AUTH0 } from '../config';
import { PRIMARY } from '../components/styles';
import AccountsService from './AccountsService';

const lock = new Auth0Lock(AUTH0.CLIENT_ID, AUTH0.DOMAIN, {
  autoclose: true,
  auth: {
    redirectUrl: AUTH0.REDIRECT_URL,
    responseType: 'token id_token',
    audience: 'https://api.staza.io',
    // params: {
    //   scope: 'email profile user_metadata',
    // }
  },
  theme: {
    logo: 'https://staza.io/assets/images/staza_logo_312x108.png',
    primaryColor: PRIMARY,
  },
  languageDictionary: {
    title: 'Task Manager',
  },
  leeway: 30,
  initialScreen: 'login',
  allowSignUp: false,
});

export default class AuthService {
  static getLock = () => {
    return lock;
  }

  // ======================================================
  // Public methods
  // ======================================================
  static login = () => {
    // Call the show method to display the widget.
    lock.show();
  }

  // ======================================================
  // Static methods
  // ======================================================
  static loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = AuthService.getAccessToken();
    // console.log('token', token);
    return !!token && !AuthService.isTokenExpired(token);
  }

  static logout() {
    // Clear user token and profile data from window.localStorage
    window.localStorage.removeItem('id_token');
    window.localStorage.removeItem('access_token');
    window.localStorage.removeItem('profile');
    AccountsService.clearAccount();
  }

  static getProfile() {
    // Retrieves the profile data from window.localStorage
    const profile = window.localStorage.getItem('profile');
    return profile ? JSON.parse(window.localStorage.profile) : {};
  }

  static setProfile(profile) {

    // Saves profile data to window.localStorage
    window.localStorage.setItem('profile', JSON.stringify(_.mapKeys(profile, (value, key) => {
      if (key.indexOf('https://staza:auth0:com/') === 0) {
        return key.substring(24);
      }

      return key;
    })));
    // Triggers profile_updated event to update the UI
  }

  static setIdToken(idToken) {
    // console.log('setIdToken', idToken);
    // Saves user token to window.localStorage
    window.localStorage.setItem('id_token', idToken);
  }

  static getIdToken() {
    // Retrieves the user token from window.localStorage
    return window.localStorage.getItem('id_token');
  }

  static setAccessToken(idToken) {
    // console.log('setAccessToken', idToken);
    // Saves user token to window.localStorage
    window.localStorage.setItem('access_token', idToken);
  }

  static getAccessToken() {
    // Retrieves the user token from window.localStorage
    return window.localStorage.getItem('access_token');
  }

  static getTokenExpirationDate() {
    const token = AuthService.getAccessToken();
    const decoded = jwtDecode(token);
    if (!decoded.exp) {
      return null;
    }

    const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  static isTokenExpired() {
    const token = AuthService.getAccessToken();
    if (!token) return true;
    const date = AuthService.getTokenExpirationDate();
    const offsetSeconds = 0;
    if (date === null) {
      return false;
    }
    return !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
  }

  static getUserInfo = (accessToken) => {
    return new Promise((resolve, reject) => {
      return lock.getUserInfo(accessToken, (err, profile) => {
        if (err) {
          console.error(err);
          return reject(err);
        }

        return resolve(profile);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/AuthService.js